import { faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import {
	Tooltip,
	TooltipArrow,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger
} from '@/components/ui/tooltip';
import { isSourceTrusted } from '@/features/Quote/services/confirmationWizard';

interface SourceIconProps {
	source: string | null;
	// Optimistically show the green check while the user is confirming this card in the
	// wizard, before the deferred save persists source="client".
	isConfirmed?: boolean;
}

const SourceIcon = ({ source, isConfirmed = false }: SourceIconProps) => {
	const { t } = useTranslation();
	// Same trusted-source rule the wizard uses to decide pending steps, so the green
	// check and the panel-open behaviour stay in lockstep.
	const isValidSource = isConfirmed || isSourceTrusted(source);

	return (
		<span className="inline-flex items-center shrink-0">
			{isValidSource ? (
				<span className="inline-flex">
					<FontAwesomeIcon
						icon={faCircleCheck}
						className="text-green-500 ml-2"
						data-testid="source-icon-check"
					/>
				</span>
			) : (
				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger asChild>
							<span className="inline-flex">
								<FontAwesomeIcon
									icon={faTriangleExclamation}
									className="text-yellow-500 ml-2 animate-pulse"
									data-testid="source-icon-warning"
								/>
							</span>
						</TooltipTrigger>
						<TooltipContent className="bg-yellow-500 text-black">
							<p>{t('quotes.settings.sourceIcon.updateDataTooltip')}</p>
							<TooltipArrow className="fill-yellow-500" />
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			)}
		</span>
	);
};

export default SourceIcon;
